import { Popover, Spin } from 'antd';
import { Check, IconProps } from 'react-feather';
import { Link } from 'react-router-dom';

import './style.less';

interface Props extends IconProps {
  redirect?: string;
  disabled?: boolean;
  popover?: string;
  loading?: boolean;
}

const CheckIcon: React.FC<Props> = ({
  redirect,
  disabled,
  popover,
  loading = false,
  ...props
}) => {
  const icon = (
    <Check
      size={20}
      cursor="pointer"
      {...props}
      onClick={!disabled ? props?.onClick : undefined}
      style={{
        cursor: disabled ? 'not-allowed' : undefined,
        color: disabled ? 'darkgray' : '#00a65a',
      }}
    />
  );

  return (
    <Popover content={popover ?? 'Marcar como lida'} className="check-icon">
      {redirect ? (
        <Link to={redirect}>{loading ? <Spin size="small" /> : icon}</Link>
      ) : loading ? (
        <Spin size="small" />
      ) : (
        icon
      )}
    </Popover>
  );
};

export default CheckIcon;
